import {FC} from "react";

const CustomerIcon: FC<{color?: string; size?: number; style?: any}> = (props: any) => {
    return <svg
        style={{...props.style}}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill={props.color ?? "inherit"}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.0044 8C16.0044 10.2091 14.2129 12 12.0029 12C9.79295 12 8.00142 10.2091 8.00142 8C8.00142 5.79086 9.79295 4 12.0029 4C14.2129 4 16.0044 5.79086 16.0044 8ZM14.0037 8C14.0037 6.89543 13.1079 6 12.0029 6C10.8979 6 10.0022 6.89543 10.0022 8C10.0022 9.10457 10.8979 10 12.0029 10C13.1079 10 14.0037 9.10457 14.0037 8ZM19.8959 18.55L18.0052 14.66C17.4883 13.6245 16.4217 12.9785 15.2642 13H8.7417C7.60216 12.9978 6.55967 13.6408 6.05068 14.66L4.10994 18.55C3.95392 18.8595 3.96935 19.2277 4.15072 19.5231C4.3321 19.8185 4.65356 19.999 5.00028 20H19.0056C19.3523 19.999 19.6738 19.8185 19.8551 19.5231C20.0365 19.2277 20.0519 18.8595 19.8959 18.55ZM7.84136 15.55L6.62089 18H17.385L16.1645 15.55C15.9934 15.2105 15.6445 14.9974 15.2642 15H8.7417C8.3614 14.9974 8.01249 15.2105 7.84136 15.55Z"
            fill={props.color ?? 'inherit'}
        />
    </svg>
}

export default CustomerIcon
